export default "__VITE_ASSET__CyBlq_dQ__"